import { Button, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { Check, X } from "lucide-react";
import type { FC } from "react";
import { FinanceDialog } from "web_myplann/Dashboard/Components/FinanceDialog";
import { useContactDialogStep } from "web_myplann/Shared/Hooks/useContactDialogStep";
import type { ContactDialogContent } from "web_myplann/Shared/Types/ContactDialogContent";
import {
	GRASS_GREEN_MYPLANN,
	LIGHT_GREEN_MYPLANN,
} from "web_myplann/Utils/constants";

export const ContactAgentDialogLegacy: FC<ContactDialogContent> = ({
	open,
	onClose,
	onConfirm,
	title,
	description,
	buttonLabel,
	successTitle,
	successDescription,
}) => {
	const theme = useTheme();
	const { step, close, confirm } = useContactDialogStep({
		open,
		onClose,
		onConfirm,
		optimistic: true,
	});

	return (
		<>
			<FinanceDialog onClose={close} open={open && step === "contact"}>
				<Stack py={2.4} px={1.6} gap={1.6}>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
					>
						<Typography
							variant="deprecatedH3"
							color={theme.palette.deprecated.grey[700]}
						>
							{title}
						</Typography>
						<IconButton onClick={close}>
							<X
								size={theme.iconSize.sm}
								color={theme.palette.deprecated.grey[700]}
							/>
						</IconButton>
					</Stack>
					<Typography
						variant="deprecatedBody1"
						color={theme.palette.deprecated.grey[700]}
					>
						{description}
					</Typography>
					<Button onClick={confirm}>{buttonLabel}</Button>
				</Stack>
			</FinanceDialog>
			<FinanceDialog
				onClose={close}
				open={open && step === "success"}
				autoFadeOut
				closeOnBackdropClick
			>
				<Stack p={2.4} alignItems="center" gap={2.4}>
					<Stack
						width={48}
						height={48}
						borderRadius={theme.shape.pillRadius}
						bgcolor={LIGHT_GREEN_MYPLANN}
						alignItems="center"
						justifyContent="center"
					>
						<Check
							size={theme.iconSize.lg}
							color={GRASS_GREEN_MYPLANN}
							style={{ strokeWidth: 2 }}
						/>
					</Stack>
					<Stack gap={0.8} textAlign="center">
						<Typography
							variant="deprecatedH3"
							color={theme.palette.deprecated.grey[700]}
						>
							{successTitle}
						</Typography>
						<Typography
							variant="deprecatedBody1"
							color={theme.palette.deprecated.grey[700]}
						>
							{successDescription}
						</Typography>
					</Stack>
				</Stack>
			</FinanceDialog>
		</>
	);
};
